import { useLogger } from '@synqo/frontend-component-library';
import { useCallback } from 'react';

const LOOP_TTL = 3000; // 3s

const scrollToNodeWithId = (id: string, killTime: number, logger: ReturnType<typeof useLogger>) => {
    if (Date.now() > killTime) {
        logger.warn('useScrollToId -> scrollToNodeWithId killed due to kill time reached.');
        return;
    }

    requestAnimationFrame(() => {
        const targetNode = document.getElementById(id);

        if (!targetNode) {
            setTimeout(() => scrollToNodeWithId(id, killTime, logger), 128);
            return;
        }

        targetNode.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
};

export function useScrollToId(buildElementId: (id: string) => string) {
    const logger = useLogger();

    const scrollToId = useCallback(
        (id: string) => {
            const elementId = buildElementId(id);
            const initialKillTime = Date.now() + LOOP_TTL;
            scrollToNodeWithId(elementId, initialKillTime, logger);
        },
        [buildElementId, logger],
    );

    return {
        scrollToId,
    };
}
